import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {HubPageConfig, HubPagePinnedHubPage, HubPagePinnedHubPageSection} from "../../utils/types/listing_page";


declare var ko: any;

export class listingPagesView_template extends vnTemplate {


    public tagTypesRequiresArticleSubContent: number[] = [154,763,972];

    protected getTemplateHtml(): string {
        return /*html*/`


            <div class="w-form w-form-large">

                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <div class="w-btn">
                         <a class="btn icon only-icon i-link" data-bind="event: { click: viewOnWebsite }"></a>-
                         <button data-bind="event: { click: onClickEditListingPage }" class="btn icon i-edit" type="button">Edit Hub Page</button>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Information</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Name</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: name"></span>
                                </dd>
                                <dt>
                                    <span>Permalink</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: permalink"></span>
                                </dd>
                                 <dt>
                                    <span>Date Created</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: dateCreated().substring(0, 10)"></span>
                                </dd>
                                <dt>
                                    <span>Date Updated</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: dateUpdated().substring(0, 10)"></span>
                                </dd>
                             </dl>
                         </div>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <dl class="double-list">
                                <dt >
                                    <span>Description</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: description"></span>
                                </dd>
                                <dt >
                                    <span>Blurb</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: blurb"></span>
                                </dd>
                               <!-- ko if: config() == 'articles' || config() == 'subContentHub' || config() == 'homepage_video' || config() == 'channel' || config() == 'theme_page'-->

                                <dt>
                                    <span>Sort Order</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: type"></span>
                                </dd>
                               <!-- /ko -->
                            </dl>
                        </div>
                    </div>
                </div>
                <!-- ko if: config() == 'theme_page' -->
                    <div class="w-form-body">
                        <div class="form-body">
                            <strong class="form-sub-title">Theme Page Options</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt><span>hide Theme Weeks archive</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: hideThemeWeeksArchive() ? 'True' : 'False'"></span>
                                    </dd>

                                    <dt><span>Hide this theme on other pages</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: doNotShowOnOtherPages() ? 'True' : 'False'"></span>
                                    </dd>

                                    <dt><span>Always pin this theme in archive on other pages</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: pinInArchiveOnOtherPages() ? 'True' : 'False'"></span>
                                    </dd>

                                    <dt><span>Background Image for this page in the archive</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: cardBackgroundImage() ? 'Set' : 'Not set'"></span>
                                    </dd>

                                    <dt><span>Title Color</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: titleColor() ?? 'None'"></span>
                                    </dd>
                                    <dt><span>Background</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: bgColor() ?? 'None'"></span>
                                    </dd>

                                    <dt><span>Text Color</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: textColor() ?? 'None'"></span>
                                    </dd>
                                    <dt><span>Poll</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: pollName() ? pollName() : (idPoll() != null ? 'Poll ID: ' + idPoll() : 'None')"></span>
                                    </dd>

                                    <dt><span>Tag</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: themePageTagName() ? themePageTagName() : 'None'"></span>
                                    </dd>

                                    <dt><span>Tags under section 'more theme weeks'</span></dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: moreThemeWeeksTagNames() ? moreThemeWeeksTagNames() : 'None'"></span>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                <!-- /ko -->
                <!-- ko if: config() == 'articles' || config() == 'subContentHub' || config() == 'homepage_video' || config() == 'homepage_thread' || config() == 'channel' || config() == 'tagHub' || config() == 'deals' || config() == 'theme_page' -->
                <!-- ko if: config() == 'articles' || config() == 'subContentHub' || config() == 'homepage_video' || config() == 'homepage_thread' || config() == 'channel' -->
                <div class="w-form-body">
                     <div class="form-body">
                         <strong class="form-sub-title pinned-articles">Pinned Articles</strong>

                         <div class="form-group">
                             <dl class="double-list">
                                 <dt>
                                     <span>Pinned Articles Enabled</span>
                                 </dt>
                                  <dd class="no-cap">
                                       <span data-bind="text: isPinnedArticlesEnabled"></span>
                                  </dd>
                                 <dt>
                                     <span>Layout</span>
                                 </dt>
                                  <dd class="no-cap">
                                       <span data-bind="text: pinnedArticlesLayout() != '' ? pinnedArticlesLayout : 'None'"></span>
                                  </dd>
                                  <dt>
                                     <span>Pinned Articles</span>
                                 </dt>
                                  <dd class="no-cap">
                                       <span data-bind="text: pinnedArticles().length == 0 ? 'None' : pinnedArticles().map(function(e) {return e.title;}).join(', ');"></span>
                                  </dd>

                             </dl>
                         </div>
                         <!-- ko if: config() == 'channel' -->
                         <div class="form-body">
                             <strong class="form-sub-title pinned-articles">Channel</strong>

                             <div class="form-group">
                                 <dl class="double-list">
                                    <dt><span>Associated Channel</span></dt>
                                    <dd class="no-cap"><span data-bind="text: channelName() != '' ? channelName : 'None'"></span></dd>
                                 </dl>
                             </div>
                         </div>
                         <!-- /ko -->
                     </div>
                     <!-- ko if: config() != 'homepage_thread' && config() != 'homepage_video' && config() != 'channel' -->
                     <div class="form-body">
                        <strong class="form-sub-title pinned-tag">Pinned Tag</strong>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>Pinned Tag</span>
                                </dt>
                                <dd class="no-cap">
                                    <!-- ko if: isPinnedTagAutomatic() -->
                                    <span data-bind="text: 'automatic - ' + pinnedTagAutomaticImageSize()"></span>
                                    <!-- /ko -->
                                    <!-- ko ifnot: isPinnedTagAutomatic() -->
                                    <span data-bind="text: pinnedTag() != '' ? pinnedTag : 'None'"></span>
                                    <!-- /ko -->
                                </dd>
                            </dl>
                        </div>
                     </div>
                     <!-- /ko -->
                </div>
                <!-- /ko -->

                 <div class="w-form-body">
                    <!-- ko if: config() != 'channel' && config() != 'tagHub' && config() != 'theme_page' -->
                    <div class="form-body">
                        <strong class="form-sub-title pinned-hub-pages" data-bind="text: config() == 'homepage_video' || config() == 'homepage_thread' || config() == 'homepage_tv_schedule' ? 'Primary Pinned Hub Pages' : 'Pinned Hub Pages'"></strong>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>Pinned Hub pages</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: pinnedListingPages().length == 0 ? 'None' : pinnedListingPages().map(function(e) {return e.listingPage.name +' '+ e.alternateTitle ;}).join(', ');"></span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <!-- /ko -->
                    <!-- ko if: config() == 'articles' || config() == 'subContentHub' || config() == 'deals' || config() == 'theme_page' || (config() == 'tagHub' && showTagHubSubContent() == true) -->
                    <div class="form-body">
                        <strong class="form-sub-title featured-article">Sub-Content Articles</strong>
                        <div class="form-group">
                            <span class="form-text" data-bind="foreach: contentTabs()">
                                <span class="bold-text-margin-bottom" data-bind="text:($data.article && $data.article.title ? $data.position + '. ' + $data.article.title + ' (' + $data.article.id + ') ' : 'None')"></span>
                            </span>
                        </div>
                    </div>
                    <!-- /ko -->

                    <!-- ko if: config() == 'homepage_video' || config() == 'homepage_thread' || config() == 'homepage_tv_schedule' -->
                    <div class="form-body">
                        <strong class="form-sub-title pinned-hub-pages">Secondary Pinned Hub Pages</strong>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>Secondary Pinned Hub pages</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: secondaryPinnedListingPages().length == 0 ? 'None' : secondaryPinnedListingPages().map(function(e) {return e.listingPage.name +' '+ e.alternateTitle ;}).join(', ');"></span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <!-- /ko -->
                 </div>

                 <!-- /ko -->
                <!-- ko if: config() != 'theme_page' && config() != 'homepage_tv_schedule' -->
                    <div class="w-form-body">
                        <div class="form-body">
                            <strong class="form-sub-title">Hub Configuration</strong>
                        </div>
                    </div>
                ${listingPagesView_template.getHubConfigurationViewHtml()}
                <!-- /ko -->
                <!-- ko if: config() != 'channel' && config() != 'tagHub' && config() != 'theme_page' && config() != 'homepage_tv_schedule' && config() != 'subContentHub' -->
                <div class="form-body embed"  data-bind="visible: (idBrand() == 5 || idBrand() == 6 || idBrand() == 22)">
                    <strong class="form-sub-title">Embed</strong>
                    <div class="form-group">
                        <div id="embedder-preview">
                            <span class="form-text" style="text-transform: capitalize;font-weight: 700;margin-top: 3rem;display: block;">none</span>
                        </div>
                    </div>
                </div>
                 <!-- /ko -->
            </div>
        `;
    }

    public static getHubConfigurationViewHtml(): string
    {
        return /* html */`
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <!-- ko if: config() == 'articles' || config() == 'subContentHub' || config() == 'homepage_video' || config() == 'homepage_thread' || config() == 'channel' -->
                                <dt>
                                    <span>Sort Order</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: type"></span>
                                </dd>
                                <dt>
                                    <span>Article Type</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: articleTypeName"></span>
                                </dd>
                                <!-- ko if: config() == 'articles' || config() == 'subContentHub' || config() == 'homepage_video' || config() == 'homepage_thread' -->
                                <dt>
                                    <span>Template</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: articleTemplateLayoutName"></span>
                                </dd>
                                <!-- /ko -->
                            <!-- /ko -->
                        </dl>
                        <!-- ko if: config() == 'articles' || config() == 'subContentHub' || config() == 'homepage_video' || config() == 'homepage_thread' -->
                            <hr style="margin: 2rem 0;">
                        <!-- /ko -->
                        <dl class="double-list">
                            <!-- ko if: config() == 'articles' || config() == 'subContentHub' || config() == 'homepage_video' || config() == 'homepage_thread' -->
                                <!-- hide this for now
                                <dt >
                                <span>Article Characteristics</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: articleCharacteristicsString() ? articleCharacteristicsString() : 'None'"></span>
                                </dd> -->
                                <dt >
                                    <span>Content types</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: contentTypes().length == 0 ? 'None' : contentTypes().map(function(e) {return e.name;}).join(', ');"></span>
                                </dd>
                                <dt data-bind="visible: segmentsEnabled()">
                                    <span>Segments</span>
                                </dt>
                                <dd class="no-cap" data-bind="visible: segmentsEnabled()">
                                    <span data-bind="text: segments().length == 0 ? 'None' : segments().map(function(e) {return e.name;}).join(', ');"></span>
                                </dd>
                            <!-- /ko -->
                            <!-- ko if: config() == 'tags' -->
                                <dt >
                                    <span>Tag Type</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: tagType()"></span>
                                </dd>
                            <!-- /ko -->
                            <!-- ko if: config() == 'tagHub' -->
                                <dt>
                                    <span>Configuration</span>
                                </dt>
                                <dd class="no-cap">
                                    <span>Tag Hub</span>
                                </dd>
                            <!-- /ko -->
                            <!-- ko if: config() == 'homepage_tv_schedule' -->
                                <dt>
                                    <span>Configuration</span>
                                </dt>
                                <dd class="no-cap">
                                    <span>TV Schedule Homepage</span>
                                </dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                </div>
                <div class="form-body">
                    <div class="form-group">
                        <!-- ko if: config() == 'articles' || config() == 'homepage_video' || config() == 'homepage_thread' -->
                            <dl class="double-list">
                                    <dt >
                                        <span>Randomize when Pinned</span>
                                    </dt>
                                    <dd class="no-cap" >
                                        <span data-bind="text: randomizePinnedArticles() ? 'True' : 'False'"></span>
                                    </dd>
                            </dl>
                            <hr style="margin: 2rem 0;">
                        <!-- /ko -->
                        <dl class="double-list">
                            <!-- ko if: config() == 'articles' || config() == 'homepage_video' || config() == 'homepage_thread' || config() == 'mods' -->
                                <dt >
                                    <span>Tags</span>
                                </dt>
                                 <dd class="no-cap " >
                                     <span data-bind="text: pinnedTags().length == 0 ? 'None' : pinnedTags().map(function(e) {return e.name + (e.type != null ? ' ' + e.formattedTagTypeAndDataset : '');}).join(', ');"></span>
                                 </dd>
                                <dt >
                                    <span>Categories</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: categories().length == 0 ? 'None' : categories().map(function(e) {return e.name;}).join(', ');"></span>
                                </dd>
                            <!-- /ko -->
                            <!-- ko if: config() == 'tags' -->
                                <dt >
                                    <span>Level 1 Filter</span>
                                </dt>
                                <dd class="no-cap " >
                                    <span data-bind="text: level1Filter() == null ? 'None' : level1Filter()"></span>
                                </dd>
                                <dt >
                                    <span>Level 2 Filter</span>
                                </dt>
                                <dd class="no-cap " >
                                    <span data-bind="text: level2Filter() == null ? 'None' : level2Filter()"></span>
                                </dd>
                                <dt >
                                    <span>Spec To Display</span>
                                </dt>
                                <dd class="no-cap " >
                                    <span data-bind="text: specToDisplay() == null ? 'None' : specToDisplay()"></span>
                                </dd>
                                <dt >
                                    <span>Spec To Display Order</span>
                                </dt>
                                <dd class="no-cap " >
                                    <span data-bind="text: specToDisplayAscDesc() == null ? 'None' : specToDisplayAscDesc()"></span>
                                </dd>
                            <!-- /ko -->

                            <!-- ko if: config() === 'tagHub' -->
                                <dt >
                                    <span>Hub Tag Selection</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: pinnedTags().length == 0 ? 'None' : pinnedTags().map(function(e) {return e.name + (e.type != null ? ' ' + e.formattedTagTypeAndDataset : '');}).join(', ');"></span>
                                </dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                    <!-- ko if: config() !== 'articles' && config() !== 'homepage_video' && config() !== 'homepage_thread' && config() !== 'homepage_tv_schedule' && config() !== 'tagHub' && config() !== 'channel' && config() !== 'mods' && config() !== 'deals' -->
                        <div class="form-group">
                            <label class="form-label">Inclusion Rules</label>
                            <dl class="double-list" data-bind="foreach: inclusionRules">
                                <dt><span data-bind="text: field.label"></span></dt>
                                <dd><span data-bind="text: tag.name + (tag.type != null ? ' ' + tag.formattedTagTypeAndDataset : '')"></span></dd>
                            </dl>
                        </div>
                    <!-- /ko -->
                </div>
                <!-- ko if: config() == 'deals' -->
                    <div class="w-form-body no-border form-group-flex featured-pinned-section">
                        <div class="form-body no-padding">
                            <strong class="form-sub-title">Primary Deals</strong>
                              <div data-bind="foreach: primaryDeals" class="featured-deals-list">
                                    <div class="form-body w-pinned">
                                        <div class="w-title">
                                            <span class="pinned-title"><span data-bind="text: '(' + id + ') ' + title"></span></span>
                                        </div>
                                         <!-- ko if: pinnedHours != '' && expiry -->
                                        <div class="no-margin">
                                           <label class="form-label icon i-hourglass">Hours Pinned: <span data-bind="text: expiry"></span></label>
                                        </div>
                                        <!-- /ko -->
                                    </div>
                              </div>
                        </div>
                        <div class="form-body no-padding">
                            <strong class="form-sub-title">Secondary Deals</strong>
                              <div data-bind="foreach: secondaryDeals" class="featured-deals-list">
                                    <div class="form-body w-pinned">
                                        <div class="w-title">
                                            <span class="pinned-title"><span data-bind="text: '(' + id + ') ' + title"></span></span>
                                        </div>
                                        <!-- ko if: pinnedHours != '' && expiry -->
                                        <div class="no-margin">
                                           <label class="form-label icon i-hourglass">Expires: <span data-bind="text: expiry"></span></label>
                                        </div>
                                        <!-- /ko -->
                                    </div>
                              </div>
                        </div>
                    </div>
                    <!-- /ko -->
            </div>
        `;
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            idBrand: ko.observable(0),
            description: ko.observable(""),
            blurb: ko.observable(""),
            blurbAuthor: ko.observable(null),
            permalink: ko.observable(""),
            content: ko.observable(""),
            config: ko.observable('articles'),
            style: ko.observable(""),
            type: ko.observable(""),
            articleTypeName: ko.observable(""),
            articleTemplateLayoutName: ko.observable(""),
            pinnedListingPages: ko.observableArray([]),
            secondaryPinnedListingPages: ko.observableArray([]),
            pinnedArticles: ko.observableArray([]),
            pinnedTag: ko.observable(""),
            isPinnedTagAutomatic: ko.observable(false),
            pinnedTagAutomaticImageSize: ko.observable("large"),
            isPinnedArticlesEnabled: ko.observable(false),
            pinnedArticlesLayout: ko.observable(""),
            pinnedTags: ko.observableArray([]),
            contentTypes: ko.observableArray([]),
            segments: ko.observableArray([]),
            categories: ko.observableArray([]),
            articleCharacteristicsString: ko.observable(),
            randomizePinnedArticles: ko.observable(),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            tagType: ko.observable(null),
            level1Filter: ko.observable(null),
            level2Filter: ko.observable(null),
            specToDisplay: ko.observable(null),
            specToDisplayAscDesc: ko.observable(null),
            embed: ko.observable(),
            inclusionRules: ko.observableArray([]),
            featuredArticleTitle: ko.observable(null),
            contentTabs: ko.observableArray([]),
            segmentsEnabled: ko.observable(false),
            channelName: ko.observable(null),
            showTagHubSubContent: ko.observable(false),
            primaryDeals: ko.observableArray([]),
            secondaryDeals: ko.observableArray([]),
            hideThemeWeeksArchive: ko.observable(false),
            doNotShowOnOtherPages: ko.observable(false),
            pinInArchiveOnOtherPages: ko.observable(false),
            cardBackgroundImage: ko.observable(null),
            themePageTagName: ko.observable(''),
            moreThemeWeeksTagNames: ko.observable(''),
            titleColor: ko.observable(null),
            bgColor: ko.observable(null),
            textColor: ko.observable(null),
            idPoll: ko.observable(null),
            pollName: ko.observable(''),
            onClickEditListingPage: function (data, event) {
                self.onClickEditListingPage(data.id());
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
            viewOnWebsite: (value, data, event) => {
                self.viewOnWebsite(value);
            },
        }
    }


    protected setListingPageData(responseParsed) {

        let listingPage = responseParsed.listingPage;
        this.getTemplateViewModel().id(listingPage.id);
        this.getTemplateViewModel().name(listingPage.name);
        this.getTemplateViewModel().description(listingPage.description);
        this.getTemplateViewModel().blurb(listingPage.blurb);
        this.getTemplateViewModel().blurbAuthor(listingPage.blurbAuthor);
        this.getTemplateViewModel().permalink(listingPage.permalink);
        this.getTemplateViewModel().content(listingPage.content);
        this.getTemplateViewModel().style(listingPage.style);
        if(listingPage.type == "trending"){

            this.getTemplateViewModel().type("Trending/Popular (Full List)");
        }else{
            this.getTemplateViewModel().type(listingPage.type);
        }
        this.getTemplateViewModel().config(listingPage.config);
        if(listingPage.config == 'theme_page'){
            this.getTemplateViewModel().hideThemeWeeksArchive(!!listingPage.hideThemeWeeksArchive);
            this.getTemplateViewModel().doNotShowOnOtherPages(!!listingPage.doNotShowOnOtherPages);
            this.getTemplateViewModel().pinInArchiveOnOtherPages(!!listingPage.pinInArchiveOnOtherPages);
            this.getTemplateViewModel().cardBackgroundImage(listingPage.cardBackgroundImage || null);
            this.getTemplateViewModel().themePageTagName(listingPage.themePageTag ? listingPage.themePageTag.name : '');
            const moreThemeWeeksTags = responseParsed.moreThemeWeeksTags || [];
            this.getTemplateViewModel().moreThemeWeeksTagNames(
                moreThemeWeeksTags.length
                    ? moreThemeWeeksTags.map((tag) => tag.name).join(', ')
                    : ''
            );
            this.getTemplateViewModel().titleColor(listingPage.titleColor || null);
            this.getTemplateViewModel().bgColor(listingPagesView_template.formatThemePageBackground(listingPage.bgColor));
            this.getTemplateViewModel().textColor(listingPage.textColor || null);
            this.getTemplateViewModel().idPoll(listingPage.idPoll || null);
            this.getTemplateViewModel().pollName(listingPage.pollName || '');
        }
        this.getTemplateViewModel().contentTabs(listingPage.contentTabs || []);
        this.getTemplateViewModel().inclusionRules(listingPage.inclusionRules);
        if(listingPage.tagType) {
            this.getTemplateViewModel().tagType(`${listingPage.tagType.name} ${listingPage.tagType.formattedDataset}`);
        }
        this.getTemplateViewModel().isPinnedArticlesEnabled(listingPage.isPinnedArticlesEnabled);
        if(listingPage.layout){
            this.getTemplateViewModel().pinnedArticlesLayout(listingPage.layout.name);
        }
        if(listingPage.pinnedArticles){
            this.getTemplateViewModel().pinnedArticles(listingPage.pinnedArticles);
        }
        // Set pinned tag automatic mode
        this.getTemplateViewModel().isPinnedTagAutomatic(listingPage.isPinnedTagAutomatic === true);
        if(listingPage.isPinnedTagAutomatic){
            this.getTemplateViewModel().pinnedTagAutomaticImageSize(listingPage.pinnedTagAutomaticImageSize || 'large');
        } else {
            // Manual mode: set pinned tag title if it exists
            if(listingPage.pinnedTag && listingPage.pinnedTag.title){
                this.getTemplateViewModel().pinnedTag(listingPage.pinnedTag.title);
            } else {
                this.getTemplateViewModel().pinnedTag('');
            }
        }

        this.getTemplateViewModel().dateCreated(listingPage.dateCreated);
        this.getTemplateViewModel().dateUpdated(listingPage.dateUpdated);
        this.getTemplateViewModel().categories(responseParsed.categories);
        this.getTemplateViewModel().articleCharacteristicsString(responseParsed.articleCharacteristicsString);
        this.getTemplateViewModel().randomizePinnedArticles(responseParsed.randomizePinnedArticles);
        this.getTemplateViewModel().pinnedTags(responseParsed.pinnedTags);
        let listingPages = responseParsed.listingPages.filter(d => (d.listingPage != null));
        this.getTemplateViewModel().pinnedListingPages(listingPages.filter((lp: HubPagePinnedHubPage) => lp.pinnedSection == HubPagePinnedHubPageSection.PRIMARY));
        this.getTemplateViewModel().secondaryPinnedListingPages(listingPages.filter((lp: HubPagePinnedHubPage) => lp.pinnedSection == HubPagePinnedHubPageSection.SECONDARY));
        this.getTemplateViewModel().contentTypes(responseParsed.contentTypes);
        this.getTemplateViewModel().segments(responseParsed.segments);
        this.getTemplateViewModel().articleTypeName(responseParsed.articleTypeName);
        this.getTemplateViewModel().articleTemplateLayoutName(responseParsed.articleTemplateLayoutName);

        if (listingPage.config === HubPageConfig.DEALS_HUB) {
            if (listingPage.deals) {
                this.setPrimaryDeals(listingPage.deals.primaryDeals || []);
                this.setSecondaryDeals(listingPage.deals.secondaryDeals || []);
            }
        }

        if (listingPage.config == 'channel') {
            this.getTemplateViewModel().channelName(listingPage.channel.name);
        }

        if (listingPage.config == 'tagHub') {
            if(responseParsed.pinnedTags && responseParsed.pinnedTags.length > 0){
                let firstPinnedTag = responseParsed.pinnedTags[0];
                if (firstPinnedTag.idType && this.tagTypesRequiresArticleSubContent.indexOf(Number(firstPinnedTag.idType)) !== -1) {
                    this.getTemplateViewModel().showTagHubSubContent(true);
                    let contentTabs = listingPage.contentTabs || [];
                    if (contentTabs.length > 0 && contentTabs[0].article) {
                        let article = contentTabs[0].article;
                        this.getTemplateViewModel().featuredArticleTitle('[' + article.id + ']' + article.title);
                    }
                }
            }
        }

        if (listingPage.config === 'deals') {
            let contentTabs = listingPage.contentTabs || [];
            if (contentTabs.length > 0 && contentTabs[0].article) {
                let article = contentTabs[0].article;
                this.getTemplateViewModel().featuredArticleTitle('[' + article.id + ']' + article.title);
            }
        }

        if(listingPage.featuredArticle){
            this.getTemplateViewModel().featuredArticleTitle(listingPage.featuredArticle.title);
        }

        if(listingPage.tagType != undefined) {
            for (let filter of listingPage.filters) {
                let field = listingPage.tagType.fields.find(el => el.id == filter.idField)
                if (field) {
                    if (filter.level == 1) {
                        this.getTemplateViewModel().level1Filter(field.label);
                    } else {
                        this.getTemplateViewModel().level2Filter(field.label);
                    }
                }
            }
        }
        if(listingPage.displayField) {
            this.getTemplateViewModel().specToDisplay(listingPage.displayField.label);
            this.getTemplateViewModel().specToDisplayAscDesc(listingPage.type);
        }

        let embedHTML = responseParsed.listingPage.embed;
        if(embedHTML){

            const embed = document.createElement('div');
            embed.innerHTML = embedHTML;

            const embedderPreview = document.getElementById('embedder-preview');

            embedderPreview.innerHTML = "";

            embedderPreview.appendChild(embed);
        }

        this.getTemplateViewModel().segmentsEnabled(responseParsed.segmentsEnabled == undefined ? false : responseParsed.segmentsEnabled);
    }

    protected getTemplateName(): string {
        return "listingPagesView_template";
    }

    private viewOnWebsite(value) {

        //prevent click to trigger onClick bindings of outer elements that are also targeted by click
        window.event.stopPropagation();
        this.caller.viewOnWebsite(value.permalink());
    }

    protected onClickEditListingPage(id: any): any {
        this.caller.onClickEditListingPage(id)
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }

    protected setIdBrand(idBrand){

        this.getTemplateViewModel().idBrand(idBrand);
    }


    public setPrimaryDeals(primaryDeals) {
        this.getTemplateViewModel().primaryDeals(primaryDeals);
    }

    public setSecondaryDeals(secondaryDeals) {
        this.getTemplateViewModel().secondaryDeals(secondaryDeals);
    }

    public getSecondaryDeals() {
        return this.getTemplateViewModel().secondaryDeals();
    }

    private static formatThemePageBackground(background): string | null {
        if (!background) {
            return null;
        }

        let parsed = background;
        if (typeof background === 'string') {
            try {
                parsed = JSON.parse(background);
            } catch (e) {
                return background;
            }
        }

        if (!parsed || typeof parsed !== 'object') {
            return null;
        }

        switch (parsed.type || 'color') {
            case 'color':
                return parsed.color || null;
            case 'gradient':
                return `Gradient: ${parsed.gradientStart || ''} to ${parsed.gradientEnd || ''} (${parsed.gradientAngle || 180}deg)`;
            case 'image':
                return parsed.image ? `Image: ${parsed.image.title || parsed.image.name || parsed.image.url || parsed.image.id}` : 'Image';
            default:
                return parsed.type;
        }
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/listingPagesView_template.ts